<template>
    <div class="modal fade" ref="dialog" :id="dialogId" data-bs-keyboard="true" tabindex="-1" aria-hidden="true" style="background-image: radial-gradient(#00000080, transparent)">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content text-dark text-start">
                <div class="modal-header">
                    <h5 class="modal-title" v-html="overrides.title || title"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="disabled"></button>
                </div>
                <div class="modal-body">
                    <p v-if="overrides.body" v-html="overrides.body"></p>
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <button v-bind="b.attr"
                            v-for="b in buttonList" :key="b"
                            :class="'btn ' + b.classes"
                            :disabled="disabled"
                            v-html="b.html"
                            @click="buttonClicked(b)"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    var dialogId = (new Date()).getTime() % 10000;
    const dlg = {
        get id() { return 'dlg' + dialogId; }
    };

    export default {
        emits: ['clickedButton', 'hidden', 'shown', 'ok', 'cancel'],
        props: {
            buttons: {
                type: Array,
                default: () => {
                    return [
                        {
                            id: 'cancel',
                            html: 'Cancel',
                            classes: 'btn-default',
                            dismiss: true
                        },
                        {
                            id: 'ok',
                            html: 'OK',
                            classes: 'btn-primary'
                        },
                    ];
                }
            },
            disabled: Boolean,
            title: {
                type: String,
                default: () => 'Message'
            },
        },
        setup(self) {
            dialogId++;
        },
        computed: {
            buttonList() {
                return (this.overrides?.buttons || this.buttons);
            }
        },
        data: function () {
            return {
                dialog: null,
                dialogId: dlg.id,
                listeners: [],
                overrides: {},
            };
        },
        mounted() {
            const vm = this;
            vm.dialog = bootstrap.Modal.getOrCreateInstance(vm.$el);
            vm.$el.addEventListener('hidden.bs.modal', e => { vm.$emit('hidden', vm); });
            vm.$el.addEventListener('shown.bs.modal', e => { vm.$emit('shown', vm); });
        },
        methods: {
            buttonClicked(btn) {
                this.$emit('clickedButton', btn.id ?? btn);
                this.listeners.forEach(listener => {
                    listener(btn.id);
                });
                let event = { id: btn.id };
                btn.click instanceof Function && btn.click(this, event);
                if (!event.canceled) {
                    btn.id && this.$emit(btn.id, this);
                    if (btn.dismiss) {
                        this.hide();
                    }
                }
            },
            find(selector) {
                return this.$el.querySelector(selector);
            },
            findAll(selector) {
                return this.$el.querySelectorAll(selector);
            },
            hide() {
                this.dialog.hide();
                this.listeners.splice(0, this.listeners.length);
            },
            on(event, func) {
                const vm = this;
                let fn = function (e) {
                    if (e === event) {
                        func.apply(event);
                        let i = vm.listeners.findIndex(l => l === fn);
                        if (i > -1) vm.listeners.splice(i, 1);
                    }
                };
                this.listeners.push(fn);
            },
            show(overrides) {
                document.body.appendChild(this.$el);
                this.overrides = overrides ?? this.overrides ?? {};
                this.dialog.show();
                return this;
            }
        }
    };
</script>